export const domain = window.location.hostname.split('.').slice(-2).join('.');

const API_URL = `https://ipm.${domain}/api/`;

export { API_URL };
